export default __webpack_public_path__ + "static/media/mobility-icon.7a45e6f7.svg";